import React, { createContext, useState } from "react";

export const SelectedAlertsContext = createContext();

export const SelectedAlertsProvider = ({ children }) => {
  const [selectedAlerts, setSelectedAlerts] = useState([]);
  // const [filteredData, setFilteredData] = useState([]);
  const [alertDetailsData, setAlertDetailsData] = useState([]);
  const [selectedAlertAndRecomm, setSelectedAlertAndRecomm] = useState([]);
  const [rejectedAlert, setRejectedAlerts] = useState([]);
  const [orLossTreeSelectedFilters, setOrLossTreeSelectedFilters] = useState([]);

  const [selections, setSelections] = useState({
    rmpm: { accepted: [], rejected: [] },
    contract: { accepted: [], rejected: [], closed: [] },
    agileOr: { accepted: [], rejected: [] },
  });

  return (
    <SelectedAlertsContext.Provider value={{ selectedAlerts, setSelectedAlerts, alertDetailsData, setAlertDetailsData, selectedAlertAndRecomm, setSelectedAlertAndRecomm, rejectedAlert, setRejectedAlerts, selections, setSelections,orLossTreeSelectedFilters, setOrLossTreeSelectedFilters }}>
      {children}
    </SelectedAlertsContext.Provider>
  );
};
